import { Edge, Node } from "@xyflow/react";
import { GAP_BETWEEN_NODES } from "@zapier/canvas-constants";
import { getVisibleDescendants } from "@zapier/canvas-state";

export default function maybeMoveNodesLeftAfterDeletion(
  nodes: Node[],
  edges: Edge[],
  createdEdges: Edge[],
) {
  // Map for optimized node lookup
  const nodeMap = Object.fromEntries(nodes.map((node) => [node.id, node]));

  // Object to store updated positions
  const updatedPositions: { [id: string]: { x: number; y: number } } = {};

  createdEdges.forEach((edge) => {
    const sourceNode = nodeMap[edge.source];
    const targetNode = nodeMap[edge.target];

    if (!sourceNode || !targetNode) return;

    const distanceApart = targetNode.position.x - sourceNode.position.x;
    const gapToReduce = distanceApart - GAP_BETWEEN_NODES;

    if (distanceApart > GAP_BETWEEN_NODES) {
      const targetNodeAndVisibleDescendants = getVisibleDescendants(
        targetNode.id,
        nodes,
        [...edges, ...createdEdges],
        true,
      );

      if (
        targetNodeAndVisibleDescendants &&
        targetNodeAndVisibleDescendants.length > 0
      ) {
        // Iterate through targetNodeAndVisibleDescendants and update the updatedPositions object
        targetNodeAndVisibleDescendants.forEach((node) => {
          const updatedX = node.position.x - gapToReduce;
          updatedPositions[node.id] = { x: updatedX, y: node.position.y };
        });
      }
    }
  });

  // Map through nodes and update positions if they are in the updatedPositions object
  return nodes.map((node) => {
    const updatedPosition = updatedPositions[node.id];
    if (updatedPosition) {
      return {
        ...node,
        position: updatedPosition,
      };
    }
    return node;
  });
}
